import token, { tokenToVars } from '../token';
import Checkbox from './checkbox';

export { Checkbox };
export default tokenToVars(Checkbox, token);
